// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\PierGroupFootmarks\SetPierGroupFootmarksRequest.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Measurement, MeasurementData, MeasurementOptions } from 'data/models/Measurement';
import { SetBerthFootmarksRequest as _SetBerthFootmarksRequest, SetBerthFootmarksRequestData as _SetBerthFootmarksRequestData, SetBerthFootmarksRequestOptions as _SetBerthFootmarksRequestOptions } from 'data/models/SetPierGroupFootmarksRequest';

// SetPierGroupFootmarksRequestData is the class that SetPierGroupFootmarksRequest serializes to/from
export interface SetPierGroupFootmarksRequestData {
	
    Berths : _SetBerthFootmarksRequestData[] | null;
	
}

// SetPierGroupFootmarksRequestOptions is the class which may be passed to the SetPierGroupFootmarksRequest constructor to define optional initial data values
export interface SetPierGroupFootmarksRequestOptions {
	
    Berths? : _SetBerthFootmarksRequestOptions[] | null;
	
}

export class SetPierGroupFootmarksRequest {
	
    public Berths : SDataArray<_SetBerthFootmarksRequest>;
	

    constructor();
    constructor(data : SetPierGroupFootmarksRequestOptions);
    constructor(data: SetPierGroupFootmarksRequestOptions | null = null) {
	    
        this.Berths = SArray<_SetBerthFootmarksRequest>([]);
	    
    }

    static key(obj : SetPierGroupFootmarksRequest) {
        return ;
    }
    
    static dataKey(obj : SetPierGroupFootmarksRequestOptions) {
        return ;
    }

    static update(obj : SetPierGroupFootmarksRequest, data : SetPierGroupFootmarksRequestOptions) {
        S.freeze(() => {
	        
	        
        });
    }
}

// SetBerthFootmarksRequestData is the class that SetBerthFootmarksRequest serializes to/from
export interface SetBerthFootmarksRequestData {
    Id : number;
	
	
    Length : MeasurementData;
    StartMark : MeasurementData;
}

// SetBerthFootmarksRequestOptions is the class which may be passed to the SetBerthFootmarksRequest constructor to define optional initial data values
export interface SetBerthFootmarksRequestOptions {
    Id : number;
	
	
    Length? : MeasurementOptions;
    StartMark? : MeasurementOptions;
}

export class SetBerthFootmarksRequest {
    public Id : DataSignal<number>;
	
	
    public Length : Measurement;
    public StartMark : Measurement;

    constructor();
    constructor(data : SetBerthFootmarksRequestOptions);
    constructor(data: SetBerthFootmarksRequestOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
	    
        this.Length = data && data.Length !== undefined ? new Measurement(data.Length) : new Measurement();
        this.StartMark = data && data.StartMark !== undefined ? new Measurement(data.StartMark) : new Measurement();
    }

    static key(obj : SetBerthFootmarksRequest) {
        return obj.Id();
    }
    
    static dataKey(obj : SetBerthFootmarksRequestOptions) {
        return obj.Id;
    }

    static update(obj : SetBerthFootmarksRequest, data : SetBerthFootmarksRequestOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.Length !== undefined) Measurement.update(obj.Length, data.Length);
            if (data.StartMark !== undefined) Measurement.update(obj.StartMark, data.StartMark);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/SetPierGroupFootmarksRequest.ts